import { shallowEqual } from 'react-redux';
import { useMMDispatchActions, useMMSelector } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getTierStreamId } from '../helpers';
import { getTiers } from '../selectors';
import { fetchMoreTiers } from '../actions';
import { PapiDeviation } from '@wix/da-papi-types';

export type WithTierProps = {
  tiers: PapiDeviation[];
  isFetchingTiers: boolean;
  hasMoreTiers: boolean;
  isTierStreamInitialized: boolean;
  fetchMoreTiers: () => void;
};

const mapStateToProps = state => {
  const streamId = getTierStreamId();
  const tiers = getTiers(state);
  return {
    tiers,
    isFetchingTiers: selectors.isFetching(state, streamId),
    isTierStreamInitialized: selectors.isInitialized(state, streamId),
    hasMoreTiers: selectors.hasMore(state, streamId),
  };
};

export const useTiers = (): WithTierProps => ({
  ...useMMSelector(mapStateToProps, shallowEqual),
  ...useMMDispatchActions({ fetchMoreTiers }),
});
